import React from 'react';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { ELIGIBILITY } from '@tmap/mmm-core/commonApp/funnelCategories';
import Question from './question';

function EligibilityFormBody(props) {
  const {
    incentive,
    fieldConfigs = [],
  } = props;
  const attestations = fieldConfigs.filter((fc) => fc.type === 'checkbox' && fc.category === ELIGIBILITY);
  return (
    <Grid container spacing={2} alignItems='center'>
      <Grid item xs={12}>
        <Typography variant='body1'>Minimum Eligibility Requirements</Typography>
      </Grid>
      {attestations.map((field) => (
        <Question field={field} data={{ incentive }} key={field.path} titleSpacing='medium' />
      ))}
    </Grid>
  );
}

export default EligibilityFormBody;
